import http from "../http";

function authenticateRegistrationNumber(payload) {
  return http("PUT", `${window.API_URL}/myInfo/social-number`, payload);
}

function authenticateOwnerBankAccount(payload) {
  return http("PUT", `${window.API_URL}/myInfo/account`, payload);
}

function getBanks() {
  return http("GET", `${window.API_URL}/config/bank-codes`);
}

function getBankName(bankCode) {
  return http("GET", `${window.API_URL}/config/banks/${bankCode}`);
}

export default {
  authenticateRegistrationNumber,
  authenticateOwnerBankAccount,
  getBanks,
  getBankName,
};
